import { ICustomerDetail } from "@interfaces";

export const getPrimaryTravellerEmail = (customers: ICustomerDetail[]): string => {
    const primaryCustomer = customers.find(
        (c) => c.is_primary === 1 || c.is_primary === true,
    );
    if (primaryCustomer?.email) return primaryCustomer.email;
    if (customers.length > 0 && customers[0].email) return customers[0].email;
    return "";
};

export const generateRandomPassword = (): string => {
    const chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%";
    let password = "";
    for (let i = 0; i < 16; i++) {
        password += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return password;
};

export interface GuestSignupResult {
    success: boolean;
    showLoginModal: boolean;
    email: string;
}

export const determineGuestSignupOutcome = (
    signupSucceeded: boolean,
    email: string,
): GuestSignupResult => {
    if (signupSucceeded) {
        return { success: true, showLoginModal: false, email };
    }
    return { success: false, showLoginModal: true, email };
};

export const canProceedWithoutSignup = (isLoggedIn: boolean): boolean => {
    return isLoggedIn;
};

export const validateGuestLoginInput = (
    email: string,
    password: string,
): { valid: boolean; error?: string } => {
    if (!email || !password) {
        return { valid: false, error: "Please enter your password" };
    }
    return { valid: true };
};

export const determineLoginOutcome = (
    hasAccessToken: boolean,
): { success: boolean; error?: string } => {
    if (!hasAccessToken) {
        return { success: false, error: "Incorrect email or password. Please try again." };
    }
    return { success: true };
};

export type PostLoginStep = "merge_cart" | "set_jwt" | "init_account";

export const getPostLoginStepOrder = (hasSessionId: boolean): PostLoginStep[] => {
    if (hasSessionId) {
        return ["merge_cart", "set_jwt", "init_account"];
    }
    return ["set_jwt", "init_account"];
};
